module.exports = __webpack_public_path__ + "static/media/certyfikat-9.f89d0447.png";